export default __webpack_public_path__ + "static/media/Business-Analysis-Skills_user-journey-with-post-it-notes.7fef6a87.jpg";